module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementInformationModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET600))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET601))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SurveyInstanceId))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET602))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SurveyTitle))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET603))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.LocationName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET614))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.checkData.LocationAddress) + " (" + _vm._s(_vm.checkData.LocationCountry) + ")\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET615))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.WaveName))])]), _vm._v(" "), (_vm.checkData.CheckoutCreatedAt) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET604))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
    _vm.checkData.CheckoutCreatedAt
  )) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.SettlementComment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET605))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SettlementComment))])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET606))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.BasePayment, "EUR")) + "\n                ")])]), _vm._v(" "), (_vm.checkData.PlusPayment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET607))]), _vm._v(" "), _c('td', {
    staticClass: "text-green"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.PlusPayment, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.MinusPayment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET608))]), _vm._v(" "), _c('td', {
    staticClass: "text-red"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.MinusPayment, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "total-background"
  }, [_c('td', {
    staticClass: "format-total-text"
  }, [_vm._v(_vm._s(_vm.lang.SET609))]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.Total, "EUR")) + "\n                ")])]), _vm._v(" "), (_vm.checkData.VatValue) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET610) + " (" + _vm._s(_vm.checkData.VatRate * 100) + "%)")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.VatValue, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.PurchaseMoney) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET611))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.PurchaseMoney, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "payout-background"
  }, [_c('td', {
    staticClass: "format-total-text"
  }, [_vm._v(_vm._s(_vm.lang.SET612))]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(
    _vm.checkData.TotalWithVatAndPurchaseMoney,
    "EUR"
  )) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SET613) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col-md-4 col-xs-5"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-md-8 col-xs-7"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "empty-row"
  }, [_c('td'), _vm._v(" "), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fabd21e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settlement/SettlementInformationModal.vue
// module id = 413
// module chunks = 1 2